// Wishlist functionality
class Wishlist {
  constructor() {
    this.wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    this.counter = document.getElementById("wishlist-counter");
    this.initButtons();
    this.setInitialStates();
    this.updateCounter();
  }

  // Add this new method
  setInitialStates(container = document) {
    container.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
      const productHandle = button.dataset.productHandle;
      if (this.isInWishlist(productHandle)) {
        button.classList.add("in-wishlist", "remove");
        button.setAttribute("aria-label", "Remove from wishlist");
      } else {
        // Ensure buttons not in wishlist don't have the classes
        button.classList.remove("in-wishlist", "remove");
        button.setAttribute("aria-label", "Add to wishlist");
      }
    });
  }

  updateCounter() {
    this.counter.textContent = this.wishlist.length || 0;
  }

  initButtons() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest("[data-wishlist-toggle]");
      if (button) {
        e.preventDefault();
        const productHandle = button.dataset.productHandle;
        this.toggleProduct(productHandle, button);
      }
    });
  }

  toggleProduct(handle, button) {
    const index = this.wishlist.indexOf(handle);
    const isRemoving = index > -1;

    if (isRemoving) {
      this.wishlist.splice(index, 1);
    } else {
      // Add to wishlist
      this.wishlist.push(handle);
    }

    // Update all buttons with the same product handle
    const allButtons = document.querySelectorAll(
      `[data-wishlist-toggle][data-product-handle="${CSS.escape(handle)}"]`
    );

    allButtons.forEach((btn) => {
      if (isRemoving) {
        btn.classList.remove("in-wishlist", "remove");
        btn.setAttribute("aria-label", "Add to wishlist");
      } else {
        btn.classList.add("in-wishlist", "remove");
        btn.setAttribute("aria-label", "Remove from wishlist");
      }
    });

    this.updateCounter();
    localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

    // Dispatch a custom event
    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: {
          handle: handle,
          action: isRemoving ? "removed" : "added",
        },
      })
    );
  }

  isInWishlist(handle) {
    return this.wishlist.includes(handle);
  }
}

// Initialize everything when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  // Initialize global instances
  window.wishlist = new Wishlist();
});
